import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';

/** @class CardSectionMixin */
/** @method */
export var CardSectionMixin = function CardSectionMixin(props) {
  return token({
    borderColor: 'Card.separatorColor',
    paddingBottom: 'Card.section.paddingBottom',
    marginBottom: 'Card.section.marginBottom',
    borderBottomWidth: 'Card.section.borderBottomWidth'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      paddingBottom = _ref.paddingBottom,
      marginBottom = _ref.marginBottom,
      _ref$borderBottomWidt = _ref.borderBottomWidth,
      borderBottomWidth = _ref$borderBottomWidt === void 0 ? 1 : _ref$borderBottomWidt;
    return css(["border-bottom:", "px solid ", ";padding-bottom:", ";margin-bottom:", ";&:last-of-type{border-bottom:0;padding-bottom:0;margin-bottom:0;}", ""], borderBottomWidth, borderColor, paddingBottom ? paddingBottom + "px" : spaceMixin('md')(props), marginBottom ? marginBottom + "px" : spaceMixin('md')(props), spacingMixin(props));
  })(props);
};